<template>
    <figure class="image is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only" style="margin-top: 30px;">
        <img src="https://assets.webbank.com/newsroom/pr54_hero-2.png" alt="WebBank Announces Philip Gitler to Lead Newly Formed Asset Finance Team">
    </figure>
    <figure class="image is-hidden-widescreen">
        <img src="https://assets.webbank.com/newsroom/pr54_small-2.png" alt="WebBank Announces Philip Gitler to Lead Newly Formed Asset Finance Team">
    </figure>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">

                    <router-link class="button is-primary is-small is-pulled-right" to="/newsroom">
                        <span class="icon"><i class="fas fa-arrow-left"></i></span>
                        <span>Back to Newsroom</span>
                    </router-link>
                    <p class="press-release">Press Release</p>
                    <br>
                    <div class="content">
                        <h2 class="news-page-title">WebBank Announces Philip Gitler to Lead Newly Formed Asset Finance Team</h2>
                        <br>
                        <p><em><small>June 3rd, 2026</small></em></p>
                        <br>
                        <p><strong>SALT LAKE CITY</strong> – WebBank today announced that Philip Gitler has been named <strong>Senior Vice
President, Head of Asset Finance</strong>, reflecting his expanded leadership of the Bank’s newly formed <strong>Asset
Finance</strong> team. The new team combines WebBank’s Lender Finance and Partner Finance businesses under
a unified platform designed to deliver integrated financing solutions across the specialty finance
ecosystem.</p>
                        <p>In his expanded role, Mr. Gitler will lead the strategic direction and growth of WebBank’s Asset Finance
business, including capital markets activities. By bringing together complementary capabilities across
Lender Finance and Partner Finance, the unified team will provide asset-backed warehouse facilities,
back-leverage solutions and other structured credit offerings to Strategic Partner platforms, fintech
companies, specialty finance companies and asset-backed private credit funds.</p>
                        <p>The formation of the Asset Finance team enhances coordination across the Bank’s platform ecosystem,
strengthens partner relationships, and supports continued balance sheet growth. It also reinforces
collaboration across internal teams to deliver scalable, long-term financing solutions aligned with partner
needs.</p>
                        <p>Mr. Gitler brings more than two decades of asset finance experience, with deep expertise across asset
classes and a strong track record of building and leading teams across the full asset lending and
investment life cycle. Since joining WebBank, he has led the expansion of the Bank’s Lender Finance
platform and helped position the business for continued growth.</p>
                        <p>“Phil brings deep market knowledge, strong leadership and a proven ability to build and scale asset
finance platforms,” said Jason Lloyd, President &amp; CEO of WebBank. “By uniting these capabilities under
one team, we are strengthening how we serve our partners, expanding our market reach and positioning
the business for long-term growth.”</p>
                        <br>
                        <p><strong>About WebBank</strong></p>
                        <p>WebBank is a Utah chartered Industrial Bank headquartered in Salt Lake City, Utah. Since its inception in 1997, WebBank has originated and funded over $273 billion in consumer and commercial credit products.  As “The Bank Behind the Brand®”, WebBank is a national issuer of consumer and small business credit products through Strategic Partner (Brand) platforms, which include retailers, manufacturers, finance companies, software as a service (SaaS) and financial technology (FinTech) companies.  The Bank is a leading player in the digital lending space, driving innovation in financial products through embedded finance with Strategic Partner platforms.  WebBank engages in a full range of banking activities including consumer and commercial loan products, revolving lines of credit, credit cards, private-label card issuance, auto-refinancing and more. The Bank provides capital in the form of asset-based lending and other credit facilities to Strategic Partner platforms, credit funds, and other lenders with a targeted focus on specialty finance assets. The Bank is also a leading provider of commercial insurance premium finance products through its wholly owned subsidiary National Partners. For more information, please visit <a href="/">www.webbank.com</a>.</p>
                        <br>
                        <p><strong>Media Contact:</strong></p>
                        <p>Shannon Hutchings</p>
                        <p><a href="mailto:shannon.hutchings@webbank.com">shannon.hutchings@webbank.com</a></p>
                    </div>

                    <div class=" modal" :class="{ 'is-active': clickout_modal }">
                        <div class="modal-background"></div>
                        <div class="modal-content">
                            <div class="box">
                                <h2 class="box-title">You are leaving our site!</h2>
                                <br>
                                <p>You will be linking to another website not owned or operated by WebBank.</p>
                                <br>
                                <p>WebBank is not responsible for the availability or content of this website
                                    and does not represent either the linked website or you, should you enter into a
                                    transaction.</p>
                                <br>
                                <p>The inclusion of any hyperlink does not imply any endorsement, investigation,
                                    verification or monitoring by WebBank of any information in any hyperlinked
                                    site. We encourage you to review their privacy and security policies which may differ
                                    from WebBank.</p>
                                <br>
                                <p>If you click &quot;Proceed&quot;, the link will open in a new window.</p>
                                <br>
                                <br>
                                <div class="field is-grouped">
                                    <div class="control">
                                        <button class="button is-link" @click="doClickout">Proceed</button>
                                    </div>
                                    <div class="control">
                                        <button class="button is-link is-light"
                                            @click="clickout_modal = false">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

    created() {
        document.title = "WebBank Announces Philip Gitler to Lead Newly Formed Asset Finance Team";
    },

    data: function () {
        return {
            clickout_modal: false,
            clickout_url: null,
        }
    },

    methods: {
        clickOutWarning: function (url) {
            this.clickout_url = url;
            this.clickout_modal = true;
        },


        doClickout: function () {
            this.clickout_modal = false;
            window.open(this.clickout_url, "_blank");
        },
    }
}
</script>
